<template>
    <section class="home-container">
        <MasterPage title="食材">
            <div slot="title-icon">
                <Icon type="ios-nutrition"/>
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                            <FormItem label="食材名称：">
                                <Input v-model="name" placeholder="请输入"/>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="食材类别：">
                                <Select v-model="typeId" @on-change="pageNum = 1" clearable placeholder="请选择">
                                    <Option v-for="item in foodMaterialTypeAllList" :value="item.id" :key="item.id">
                                        {{ item.name }}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="营养物质：">
                                <Select v-model="nutritionIdList" multiple filterable placeholder="请选择">
                                    <Option v-for="item in nutritionAllList" :value="item.id" :key="item.id">
                                        {{ item.name + '（' + item.forShort + '） - ' + item.englishName }}
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="食材状态：">
                                <Select v-model="isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                    <Option value="false">启用</Option>
                                    <Option value="true">删除</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <!-- <div slot="btns">
                <Button type="primary" icon="md-upload" @click="addModel = true">导入</Button>
              <Upload
                ref="uploadFile"
                multiple
                type="drag"
                :format="['csv']"
                accept="csv/*"
                :before-upload="fileBefore"
                :on-success="fileSuccess"
                :on-error="fileError"
                action="food/file/importFood">
                <Button icon="ios-cloud-upload-outline">导入</Button>
              </Upload>
            </div> -->
            <div slot="search">
              <div style="display:flex;gap: 10px;">
                  <Upload
                    ref="uploadFile"
                    multiple
                    type="drag"
                    :format="['csv']"
                    accept="csv/*"
                    :before-upload="fileBefore"
                    :on-success="fileSuccess"
                    :on-error="fileError"
                    action="food/file/importFood">
                    <Button icon="ios-cloud-upload-outline">导入</Button>
                  </Upload>
                  <div>
                    <Button type="primary" icon="md-add" @click="addModel = true">添加</Button>

                  </div>

              </div>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange"
                      :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增食材" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="食材名称：">
                    <Input v-model="itemAdd.name" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <!--<FormItem label="食材单位：">-->
                <!--<Input v-model="itemAdd.unit" autocomplete="new-password" placeholder="请输入" />-->
                <!--</FormItem>-->
                <FormItem label="食材类别：">
                    <Select v-model="itemAdd.typeId" placeholder="请选择">
                        <Option v-for="item in foodMaterialTypeAllList" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="升糖指数(GI)：">
                    <InputNumber :min="0" style="width: 100%" v-model="itemAdd.GI" autocomplete="new-password"
                                 placeholder="请输入"/>
                </FormItem>
                <FormItem label="血糖负荷(GL)：">
                    <InputNumber :min="0" style="width: 100%" v-model="itemAdd.GL" autocomplete="new-password"
                                 placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材品牌：">
                    <Input v-model="itemAdd.brand" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材产地：">
                    <Input v-model="itemAdd.origin" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材品种：">
                    <Input v-model="itemAdd.variety" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="饮食DIY：">
                    <div style="display: flex;flex-direction: row;">
                        <div v-if="currentArticle" style="margin-right: 5px">
                            {{currentArticle ? currentArticle['title'] : ''}}
                        </div>
                        <Button type="primary" size="large" @click="bindArticle">选择</Button>
                    </div>
                </FormItem>
                <!--<FormItem label="食材图片：">-->
                <!--<Upload-->
                <!--ref="uploadImage"-->
                <!--multiple-->
                <!--type="drag"-->
                <!--:format="['jpg','jpeg','png']"-->
                <!--accept="image/*"-->
                <!--:before-upload="fileBefore"-->
                <!--:on-success="fileSuccess"-->
                <!--:on-error="fileError"-->
                <!--action="food/file/upload">-->
                <!--<div :style="{backgroundImage: 'url(\'' + itemAdd.picUrl + '\')',padding: '60px 0',backgroundRepeat:'no-repeat',backgroundSize:'contain',backgroundPosition:'center' }">-->
                <!--<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>-->
                <!--<p>单击或拖动图片以上传</p>-->
                <!--</div>-->
                <!--</Upload>-->
                <!--</FormItem>-->
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改食材" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="食材名称：">
                    <Input v-model="updateInfoItem.name" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <!--<FormItem label="食材单位：">-->
                <!--<Input v-model="updateInfoItem.unit" autocomplete="new-password" placeholder="请输入" />-->
                <!--</FormItem>-->
                <FormItem label="食材类别：">
                    <Select v-model="updateInfoItem.typeId" placeholder="请选择">
                        <Option v-for="item in foodMaterialTypeAllList" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="升糖指数(GI)：">
                    <InputNumber :min="0" style="width: 100%" v-model="updateInfoItem.gi" autocomplete="new-password"
                                 placeholder="请输入"/>
                </FormItem>
                <FormItem label="血糖负荷(GL)：">
                    <InputNumber :min="0" style="width: 100%" v-model="updateInfoItem.gl" autocomplete="new-password"
                                 placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材品牌：">
                    <Input v-model="updateInfoItem.brand" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材产地：">
                    <Input v-model="updateInfoItem.origin" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="食材品种：">
                    <Input v-model="updateInfoItem.variety" autocomplete="new-password" placeholder="请输入"/>
                </FormItem>
                <FormItem label="饮食DIY：">
                    <div style="display: flex;flex-direction: row;">
                        <div v-if="currentArticle" style="margin-right: 5px">
                            {{currentArticle ? currentArticle['title'] : ''}}
                        </div>
                        <Button type="primary" size="large" @click="bindArticle">选择</Button>
                    </div>
                </FormItem>
                <!--<FormItem label="食材图片：">-->
                <!--<Upload-->
                <!--ref="uploadImageUpdate"-->
                <!--multiple-->
                <!--type="drag"-->
                <!--:format="['jpg','jpeg','png']"-->
                <!--accept="image/*"-->
                <!--:before-upload="fileBefore"-->
                <!--:on-success="fileSuccess_update"-->
                <!--:on-error="fileError"-->
                <!--action="food/file/upload">-->
                <!--<div :style="{backgroundImage: 'url(\'' + updateInfoItem.picUrl + '\')',padding: '60px 0',backgroundRepeat:'no-repeat',backgroundSize:'contain',backgroundPosition:'center' }">-->
                <!--<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>-->
                <!--<p>单击或拖动图片以上传</p>-->
                <!--</div>-->
                <!--</Upload>-->
                <!--</FormItem>-->
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>

        <Modal v-model="bindDietGuidelinesModel" width="70%" title="绑定饮食原则">
            <Form :label-width="80">
                <FormItem>
                    <Col span='2' type="flex" justify="center" align='center'>{{this.openModel.name}}</Col>
                    <Col span='7' type="flex" justify="center" align='center'>原则名称</Col>
                    <Col span='8' type="flex" justify="center" align='center'>原则描述</Col>
                    <Col span='7' type="flex" justify="center" align='center'>可选项</Col>
                </FormItem>
                <FormItem
                        v-for="(item, index) in dietGuidelinesList"
                        :key="item.index">
                    <Row>
                        <Col span='2' type="flex" justify="center" align='center'>
                            <div>{{index+1}}</div>
                        </Col>
                        <Col span='7' type="flex" justify="center" align='center'>
                            <div>{{item.name}}</div>
                        </Col>
                        <Col span='8' type="flex" justify="center" align='center'>
                            <div style="min-height: 32px">{{item.description}}</div>
                        </Col>
                        <Col span="7" type="flex" justify="center" align='center'>
                            <Select clearable v-model="item.bindDetailList" style="max-width:200px">
                                <Option
                                        v-for="sonItem in item.detailList"
                                        :value="sonItem.id"
                                        :key="sonItem.name"
                                >
                                    {{ sonItem.name}}
                                </Option>
                            </Select>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="bindDietGuidelinesModel = false">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading"
                        @click="onBindDietGuidelinesToUser(dietGuidelinesList)">确定
                </Button>
            </div>
        </Modal>
        <Modal v-model="bindModel" width="70%" title="绑定食材营养物质" @on-cancel="cancelNutritionTypeVOList">
          <Form :label-width="80">
                <FormItem label="食材">
                  <Row>
                        <Col span="12">
                            <Select filterable v-model="food.id" placeholder="请选择">
                                  <Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </Col>
                        <Col span="8" offset="1">
                            <Input type="text" v-model="food.value" placeholder="请输入重量">
                                <span slot="append" style="max-width: 50px">克</span>
                            </Input>
                        </Col>
                        <Col span="3">
                            <Button type="dashed" long @click="addFoodNutrition(food.id, food.value)" icon="md-add">导入</Button>
                        </Col>
                    </Row>
                </FormItem>
                <!-- <FormItem>
                    <Row>
                        <Col span="12">
                            <Button type="dashed" long @click="handleAdd" icon="md-add">添加新食材</Button>
                        </Col>
                    </Row>
                </FormItem> -->
          </Form>
            <Form :label-width="80">
                <FormItem
                        v-for="(nutritionTypeVO, index) in nutritionTypeVOList"
                        :key="nutritionTypeVO.index"
                        :label="'营养物质 ' + (index+1)">
                    <Row>
                        <Col span="12">
                            <Select @on-change="selectChange" filterable v-model="nutritionTypeVO.id" placeholder="请选择">
                                <Option v-for="item in nutritionAllList" :disabled="item.disabled" :value="item.id"
                                        :key="item.id">{{ item.name + '（' + item.forShort + '） - ' + item.englishName }}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="6" offset="1">
                            <Input type="text" v-model="nutritionTypeVO.value" placeholder="请输入含量">
                                <span slot="append" style="max-width: 50px">{{nutritionTypeVO.foodNutritionUnit}}</span>
                            </Input>
                        </Col>
                        <Col span="2" style="display: flex;justify-content: center">
                            <Tooltip placement="top" theme="light">
                                <Radio @on-change="changeRadio(index)" v-model="nutritionTypeVO.isKey"
                                       style="margin: 0"></Radio>
                                <div slot="content">
                                    <p>重点营养物质</p>
                                </div>
                            </Tooltip>
                        </Col>
                        <Col span="3" style="display: flex;justify-content: center">
                            <Button @click="handleRemove(index)">删除</Button>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem>
                    <Row>
                        <Col span="12">
                            <Button type="dashed" long @click="handleAdd" icon="md-add">添加新的营养物质</Button>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
            <p style="color: #c3c3c3;text-align: center;">每种食材固定绑定能量、蛋白质和有机物三种营养物质，不可进行删除</p>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelNutritionTypeVOList">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading" @click="bindItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="食材详情" width="600" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Row>
                    <Col span="12">
                        <FormItem label="食材名称：">
                            {{infoItem.name}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="食材单位：">
                            {{infoItem.unit}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="食材类别：">
                            {{infoItem.foodMaterialType.name}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="升糖指数(GI)：">
                            {{infoItem.gi}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="血糖负荷(GL)：">
                            {{infoItem.gl}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="食材品牌：">
                            {{infoItem.brand}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="食材产地：">
                            {{infoItem.origin}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="食材品种：">
                            {{infoItem.variety}}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="饮食DIY：">
                            <div style="display: flex;flex-direction: row;">
                                <div v-if="currentArticle" style="margin-right: 5px">
                                    {{currentArticle ? currentArticle['title'] : ''}}
                                </div>
                                <!--<Button type="primary" size="large" @click="bindArticle">选择</Button>-->
                            </div>
                        </FormItem>
                    </Col>
                </Row>
                <!--<FormItem label="食材图片：">-->
                <!--<img :src="infoItem.picUrl" style="max-height: 125px;max-width: 100%">-->
                <!--</FormItem>-->
            </Form>
            <Form label-position="top">
                <FormItem label="营养物质：">
                    <Table stripe max-height="250" :columns="columnsInfo" :data="infoItem.nutritionTypeList"></Table>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="DIYModel" title="选择饮食DIY" width="70%" @on-cancel="articleCancle">
            <Form :label-width="80">
                <Row>
                    <Col span="12">
                    <FormItem label="文章标题：">
                        <Input v-model="title" placeholder="请输入" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="创建时间：">
                        <DatePicker v-model="createTime" style="width: 100%" type="daterange" placement="bottom-end" placeholder="请选择文章创建时间"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="创建账户：">
                        <Select v-model="createUser" clearable placeholder="请选择">
                            <Option v-for="item in systemUserAllList" :value="item.loginName" :key="item.loginName">
                                {{ item.loginName + "（" + item.realName + "）" }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem>
                            <Button type="info" icon="ios-search" @click="pageFindArticleItem">查询</Button>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem>
                    <Table stripe :loading="tableLoading" :columns="articleColumns1" :data="articlesDataList"></Table>
                </FormItem>
                <FormItem>
                    <Page :total="articlePageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
                </FormItem>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'

    export default {
        components: {
            MasterPage
        },
        data() {
            return {
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '食材名称',
                        key: 'name',
                        ellipsis: true,
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '食材单位',
                        key: 'unit',
                        ellipsis: true,
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '食材类别',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            return h('span', this.dataList[params.index].foodMaterialType.name)
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted) {
                                return h('span', '已删除')
                            } else {
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth: 400,
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted) {
                                return h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon: 'md-unlock',
                                        label: "small",
                                    },
                                    on: {
                                        click: () => {
                                            this.reuseItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '启用')
                            } else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon: 'md-create',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon: 'ios-list-box',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.infoItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '详情'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon: 'ios-nutrition',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.bindItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '绑定营养物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon: 'ios-nutrition',
                                            label: "small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onClickDietGuidelines(this.dataList[params.index])
                                            }
                                        }
                                    }, '绑定饮食原则'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon: 'md-trash',
                                            label: "small",
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                ]);
                            }
                        }
                    }
                ],
                columns2: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '原则名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '描述',
                        key: 'description',
                        align: 'center',
                    },
                    {
                        title: '可选项',
                        align: 'center'
                    }
                ],
                dataList: [],
                tableLoading: false,
                addModel: false,
                addLoading: false,
                updateModel: false,
                updateLoading: false,
                bindDietGuidelinesModel: false,
                dietGuidelineOptional: '允许',
                bindModel: false,
                bindLoading: false,
                infoModel: false,
                columnsInfo: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.name + '（' + item.forShort + '） - ' + item.englishName)
                        },
                    },
                    {
                        title: '含量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.value + ' ' + item.unit)
                        },
                    },
                    {
                        title: '重点营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.infoItem.nutritionTypeList[params.index]
                            return h("span", item.isKey ? '是' : '')
                        },
                    },
                ],
                openModel: "",
                name: '',
                typeId: '',
                dietGuidelinesList: [], // 所有原则
                dietGuidelinesListFood: [], // 食材绑定的原则
                nutritionIdList: [],
                isDeleted: 'false',
                foodMaterialTypeAllList: [],
                nutritionAllList: [],
                nutritionTypeVOList: [],
                nutritionTypeVO: 0,
                foodMaterialId: '',
                foodMaterialName: '',
                pageNum: 1,
                pageSize: 20,
                pageTotal: 0,
                itemAdd: {
                    name: '',
                    unit: '克',
                    typeId: '',
                    brand: '',
                    origin: '',
                    variety: '',
                    GI: 0,
                    GL: 0,
                },
                updateInfoItem: {},
                infoItem: {foodMaterialType: ''},
                DIYModel: false,
                title:'', //文章名称查询
                createTime:[],//文章创建时间查询
                createUser:'',//文章创建人查询
                articlesDataList:[],
                articlePageTotal: 0,
                articlePageNum:1,
                articlePageSize:20,
                articleColumns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '文章标题',
                        key: 'title',
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '文章简介',
                        align: 'center',
                        tooltip: true,
                        ellipsis: true,
                        render: (h, params) => {
                            return h('span', this.articlesDataList[params.index].introduction)
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:40,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.selectAriticle(this.articlesDataList[params.index])
                                        }
                                    }
                                }, '选择'),
                            ]
                            return h("div",Buttons)
                        }
                    }
                ],
                systemUserAllList:[],
                currentArticle: null,
                foodMaterialAllList: [],
                food: {
                  id: null,
                  value: 0
                }
            }
        },
        created() {
            this.pageFindItem()
            this.pageFindArticleItem()
            this.pageAllSystemUser()
            this.findFoodMaterialTypeAllList()
            this.findNutritionAllList()
            this.findAllFoodMaterial()
        },
        methods: {
            fileBefore(file){
                this.$refs.uploadFile.clearFiles()
                // debugger
                if (file.type.toLowerCase() != 'text/csv' ) {
                    this.$Message.warning('只能上传csv文件');
                    return false
                }
                return true
            },
            fileSuccess(response){
                this.$Notice.success({title: response.message});
                // this.pageFindItem()
            },
            fileSuccess_update(response){
                this.$Notice.success({title: response.message});
                this.pageFindItem()
                console.log('response_update', response)
            },
            fileError(error){
                this.$Notice.error({title:'导入失败',desc: error.message});
            },

            pageAllSystemUser(){
                this.$http.post('systemUser/list',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.systemUserAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'后台账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            bindArticle() {
                this.DIYModel = true
//                this.articlesDataList = []
                this.articlePageNum = 1
                this.articlePageSize = 20
            },
            // 选择文章
            selectAriticle (article) {
                this.currentArticle = article
                this.DIYModel = false
                console.log('this.currentArticle', this.currentArticle)
            },
            articleCancle () {

            },
            pageChange(value){
                this.articlePageNum = value
                this.pageFindArticleItem()
            },
            pageSizeChange(value){
                this.articlePageSize = value
                this.pageFindArticleItem()
            },
            pageFindArticleItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('articles/list',{
                    title:this.title,
                    createStartTime:this.createTime[0] == undefined || this.createTime[0] == "" ? new Date(undefined):this.createTime[0]+"",
                    createEndTime:this.createTime[1] == undefined || this.createTime[1] == "" ? new Date(undefined):this.createTime[1]+"",
                    createUser:this.createUser == undefined ? "":this.createUser,
                    statusList:1,
                    pageSize:this.articlePageSize,
                    type: '饮食',
                    currentPage:this.articlePageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.articlesDataList = msg.data.list
                        this.articlePageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'文章列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageChange(value) {
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value) {
                this.pageSize = value
                this.pageFindItem()
            },
            findFoodMaterialTypeAllList() {
                this.$http.post('foodMaterialType/list', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialTypeAllList = msg.data.list
                    } else {
                        this.$Notice.error({title: '食材类别查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            findNutritionAllList() {
                this.$http.post('nutrition/list', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.nutritionAllList = msg.data.list.map((item) => {
                            item['disabled'] = false
                            return item
                        })
                    } else {
                        this.$Notice.error({title: '营养物质查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem() {
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('foodMaterial/list', {
                    name: this.name ? this.name : null,
                    typeId: this.typeId ? this.typeId : null,
                    nutritionIdList: this.nutritionIdList.join(","),
                    isDeleted: this.isDeleted ? this.isDeleted : null,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    } else {
                        this.$Notice.error({title: '食材查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            findAllFoodMaterial(){
                this.$http.post('foodMaterial/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = []
                        for (let i in msg.data.list) {
                            if (msg.data.list[i].nutritionTypeList.length > 0) {
                                this.foodMaterialAllList.push(msg.data.list[i])
                            } else {
                            }
                        }
                    }else {
                        this.$Notice.error({title:'食材查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            addItem() {
                if (this.itemAdd.name.length <= 0) {
                    return this.$Message.warning('请输入食材名称');
                }
                // if (this.itemAdd.unit.length <= 0){
                //     return this.$Message.warning('请输入食材单位');
                // }
                if (this.itemAdd.typeId.length <= 0) {
                    return this.$Message.warning('请选择食材类别');
                }
                // if (this.itemAdd.picUrl.length <= 0){
                //     return this.$Message.warning('请上传食材图片');
                // }
                this.addLoading = true
                this.$http.post('foodMaterial/add', {
                    name: this.itemAdd.name,
                    unit: this.itemAdd.unit,
                    brand: this.itemAdd.brand,
                    origin: this.itemAdd.origin,
                    variety: this.itemAdd.variety,
                    typeId: this.itemAdd.typeId,
                    picUrl: this.itemAdd.picUrl,
                    GI: this.itemAdd.GI,
                    GL: this.itemAdd.GL,
                    articleId: this.currentArticle ? this.currentArticle.id : null
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材新增成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材新增失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item) {
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                this.currentArticle = this.updateInfoItem['articles']
                this.updateModel = true
            },
            updateItem() {
                if (this.updateInfoItem.name.length <= 0) {
                    return this.$Message.warning('请输入食材名称');
                }
                // if (this.updateInfoItem.unit.length <= 0){
                //     return this.$Message.warning('请输入食材单位');
                // }
                if (this.updateInfoItem.typeId.length <= 0) {
                    return this.$Message.warning('请选择食材类别');
                }
                // if (this.updateInfoItem.picUrl.length <= 0){
                //     return this.$Message.warning('请上传食材图片');
                // }
                this.updateLoading = true
                if (this.currentArticle) {
                    this.updateInfoItem['articleId'] = this.currentArticle.id
                }
                this.$http.post('foodMaterial/updateFood',
                    this.updateInfoItem
                    , {emulateJSON: false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材修改成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材修改失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem() {
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.bindModel = this.bindLoading = this.infoModel = false
                this.itemAdd.name = this.itemAdd.GI = this.itemAdd.GL = ''
                this.currentArticle = null
            },
            selectChange() {
                for (let i in this.nutritionAllList) {
                    let nutrition = this.nutritionAllList[i]
                    let flag = true
                    for (let j in this.nutritionTypeVOList) {
                        let nutritionTypeVO = this.nutritionTypeVOList[j]
                        if (nutritionTypeVO.id === nutrition.id) {
                            nutritionTypeVO.foodNutritionUnit = nutrition.unit
                            flag = false
                            nutrition.disabled = true
                            break
                        }
                    }
                    if (flag) {
                        nutrition.disabled = false
                    }
                }
            },
            cancelNutritionTypeVOList() {
                this.nutritionTypeVOList.length = 0
                this.nutritionAllList.map((item) => {
                    return item.disabled = false
                })
                this.bindModel = this.bindLoading = false
                this.nutritionTypeVO = 0
            },
            handleAdd() {
                this.nutritionTypeVOList.push({
                    index: this.nutritionTypeVO,
                    value: '',
                    foodMaterialId: this.foodMaterialId,
                    id: '',
                    isKey: false,
                    foodNutritionUnit: ''
                })
                this.nutritionTypeVO++
            },
            handleRemove(index) {
                if ([1, 2, 3].includes(this.nutritionTypeVOList[index].id)) {
                    return this.$Notice.warning({title: '固定营养物质无法删除'});
                }
                this.nutritionAllList.forEach((item) => {
                    if (item.id === this.nutritionTypeVOList[index].id) {
                        item.disabled = false
                        return
                    }
                })
                this.nutritionTypeVOList.splice(index, 1)
            },
            changeRadio(index) {
                for (let i = 0; i < this.nutritionTypeVOList.length; i++) {
                    this.nutritionTypeVOList[i].isKey = false
                }
                this.nutritionTypeVOList[index].isKey = true
                this.$forceUpdate()
            },
            async getDietGuidelinesList(foodId) {
                this.$http.post('dietGuidelines/list', {
                    isDeleted: this.isDeleted,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietGuidelinesList = msg.data
                        this.getDietGuidelinesListFood(foodId)
                    } else {
                        this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            async getDietGuidelinesListFood(value) {
                this.$http.post('dietGuidelines/listFood', {
                    foodMaterialId: value.id,
                    isDeleted: this.isDeleted,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietGuidelinesListFood = msg.data
                        for (let i = 0; i < this.dietGuidelinesList.length; i++) {
                            this.dietGuidelinesList[i].bindDetailList = ''
                            this.dietGuidelinesList[i].bindDetailListId = ''
                            for (let j = 0; j < this.dietGuidelinesListFood.length; j++) {
                                if (this.dietGuidelinesList[i].id === this.dietGuidelinesListFood[j].id) {
                                    this.dietGuidelinesList[i].bindDetailList = this.dietGuidelinesListFood[j].detailList[0].id
                                    this.dietGuidelinesList[i].bindDetailListId = this.dietGuidelinesListFood[j].detailList[0].id
                                }
                            }
                        }
                        this.bindDietGuidelinesModel = true
                    } else {
                        this.$Notice.error({title: '获取食材已绑定原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            async onClickDietGuidelines(value) {
                this.getDietGuidelinesList(value)
                this.openModel=value
                this.foodMaterialId = value.id
            },
            bindItem_modal(item) {
                this.foodMaterialName = item.name
                this.foodMaterialId = item.id
                if (item.nutritionTypeList.length > 0) {
                    item.nutritionTypeList.map((i, index) => {
                        this.nutritionTypeVOList.push({
                            index: this.nutritionTypeVO++,
                            value: i.value,
                            foodMaterialId: this.foodMaterialId,
                            id: i.id,
                            isKey: i.isKey,
                            foodNutritionUnit: i.unit
                        })
                        this.selectChange(i.id, index)
                    })
                } else {
                    for (let j = 0; j < this.nutritionAllList.length; j++) {
                        if ([1, 2, 3].includes(this.nutritionAllList[j].id)) {
                            let i = this.nutritionAllList[j]
                            this.nutritionTypeVOList.push({
                                index: this.nutritionTypeVO++,
                                value: i.value,
                                foodMaterialId: this.foodMaterialId,
                                id: i.id,
                                isKey: false,
                                foodNutritionUnit: i.unit
                            })
                            this.nutritionAllList[j].disabled = true
                        }
                    }
                }
                this.bindModel = true
            },
            addFoodNutrition(foodId, value) {
                this.$http.post('foodMaterial/detail2', {
                    foodMaterialId: foodId,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {                        
                        let msg = res.body
                        if (msg.success) {
                          let food = msg.data
                          food.nutritionTypeList.forEach(i => {

                            let exist = false
                            let nutritionValue = (Number(i.value) * value / 100)
                            this.nutritionTypeVOList.forEach(item => {
                              // 已存在项的值相加
                              if(i.id == item.id) {
                                item.value = (item.value ? Number(item.value) : 0) + nutritionValue
                                exist = true
                              }
                            })
                            if(!exist) {
                              // 不存在，则添加新的
                                this.nutritionTypeVOList.push({
                                index: this.nutritionTypeVOList.length + 1,
                                value: nutritionValue,
                                foodMaterialId: this.foodMaterialId,
                                id: i.id,
                                isKey: i.isKey ? i.isKey : false,
                                foodNutritionUnit: i.unit
                            })
                            }
                          })
                          console.log('this.nutritionTypeVOList: ', this.nutritionTypeVOList)
                        } else {
                            this.$Notice.error({title: '食材查询失败', desc: msg.message});
                        }
                    } else {
                        this.$Notice.error({title: '食材查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            onBindDietGuidelinesToUser(value) {
                let str = value.map(function (elem, index) {
                    return elem.bindDetailList;
                }).join(",");
                this.$http.post('dietGuidelines/addFood', {
                    foodMaterialId: this.foodMaterialId,
                    detailIds: str,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材原则绑定成功'});
                        this.bindDietGuidelinesModel = false
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材原则绑定失败', desc: msg.message});
                    }
                }, function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            bindItem() {
                let flag = false
                let keyFlag = true
                this.nutritionTypeVOList.forEach(function (item) {
                    if (item.id.toString().length <= 0 || item.value == undefined || item.value.length <= 0) {
                        flag = true
                    }
                    if (item.isKey) {
                        keyFlag = false
                    }
                })
                if (flag || this.nutritionTypeVOList.length <= 0) {
                    return this.$Message.warning('请填写完整数据');
                }
                if (keyFlag) {
                    return this.$Message.warning('请选择重点营养物质');
                }
                this.bindLoading = true
                this.$http.post('foodMaterial/update', {
                    foodId: this.foodMaterialId,
                    nutritionTypeVOList: JSON.stringify(this.nutritionTypeVOList),
                }).then(function (res) {
                    this.cancelNutritionTypeVOList()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材绑定营养物质成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材绑定营养物质失败', desc: msg.message});
                    }
                }, function (res) {
                    this.cancelNutritionTypeVOList()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item) {
                this.$Modal.confirm({
                    title: '确认删除食材“' + item.name + '”',
                    loading: true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item) {
                this.$http.post('foodMaterial/delete', {
                    id: item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材删除成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材删除失败', desc: msg.message});
                    }
                }, function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reuseItem_modal(item) {
                this.$Modal.confirm({
                    title: '确认启用食材“' + item.name + '”',
                    loading: true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item) {
                this.$http.post('foodMaterial/reuse', {
                    id: item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食材启用成功'});
                        this.pageFindItem()
                    } else {
                        this.$Notice.error({title: '食材启用失败', desc: msg.message});
                    }
                }, function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            infoItem_modal(item) {
                this.infoItem = item
                this.currentArticle = item['articles']
                this.infoModel = true
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container {

    }
</style>


